import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ApiService from "../../../services/ApiService";
import { DotLoaderComp } from "../../../components/DotLoader/index";
import { useParams } from "react-router-dom";
// import html2pdf from "html2pdf.js";
// import { commasNumber1 } from "../../utils/commasNumber1";

const columns = [
  {
    field: "age",
    headerName: "Age",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "title",
    headerName: "Relation",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
];

const ViewQuote = () => {
  const { id } = useParams();
  const [quote, setQuote] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  // PDF download code remains commented
  // const handleDownload = () => {
  //   const element = document.getElementById('download-the-page');
  //   const opt = {
  //     margin: 0.5,
  //     filename: 'quotes.pdf',
  //     image: { type: 'jpeg', quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  //   };
  //   html2pdf().from(element).set(opt).save();
  // };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await ApiService.getQuoteByIdManagement(id);
        setQuote(data);
        // Parse members from JSON string; assume each member is a simple value (e.g. age)
        let parsedMembers = [];
        try {
          const rawMembers = JSON.parse(data?.members);
          parsedMembers = rawMembers.map((member, index) => ({
            id: index + 1,
            age: member, // assuming member is age; adjust if needed
            title: index === 0 ? "Primary" : `Member ${index}`, // First is Primary, then Member 1, Member 2, etc.
          }));
        } catch (err) {
          console.error("Error parsing members:", err);
        }
        setMembers(parsedMembers);
      } catch (err) {
        console.log("error", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  // Utility to format numbers with commas
  const commasNumber1 = (num) => {
    if (num == null || isNaN(num)) {
      return "0";
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  if (loading) {
    return (
      <div
        style={{ backgroundColor: "#f9f7f2" }}
        className="h-full flex items-center justify-center"
      >
        <DotLoaderComp />
      </div>
    );
  }

  // Parse selected plans from quote; it's stored as a JSON string
  let selectedPlans = [];
  if (quote && quote.selected_plans) {
    try {
      selectedPlans = JSON.parse(quote.selected_plans);
      console.log("selected plans", selectedPlans);
    } catch (e) {
      console.error("Error parsing selected_plans", e);
    }
  }
  // Use the first plan's data for display if available
  const firstPlan = selectedPlans.length > 0 ? selectedPlans[0] : null;

  return (
    <div>
      <div className="flex justify-between items-center p-4 ">
        <div className="text-2xl font-bold">
          <h1 className="text-[#012949]">Quote Details</h1>
        </div>
        {/* <div className="me-5">
          <button
            type="button"
            className="px-4 py-2 bg-orangeColor rounded-[8px] font-inter text-base font-bold text-white"
            onClick={handleDownload}
          >
            Download
          </button>
        </div> */}
      </div>
      <div id="download-the-page" className="p-4">
        {/* Header with client details */}
        <div className="flex items-center justify-between bg-white rounded-[18px] p-5 flex-col sm:flex-row">
          <div></div>
          <div className="hidden md:block"></div>
          <div className="text-center me-10">
            <h1 className="font-bold text-[20px] text-xl">
              {quote?.first_name} {quote?.last_name}
            </h1>
            <p className="text-gray-800 text-base">{quote?.email}</p>
            {/* <p className="text-gray-800 text-base">{quote?.phone || "N/A"}</p> */}
          </div>
          <div className="items-end space-y-3 me-5 text-right mt-4 md:mt-0">
            <div className="flex gap-2">
              <h1 className="font-bold">Quote Date:</h1>
              <span className="text-gray-800 ">
                {quote?.date
                  ? new Date(quote.date).toLocaleDateString()
                  : "N/A"}
              </span>
            </div>
            <div className="flex gap-2">
              <h1 className="font-bold">Residency:</h1>
              <span className="text-gray-800 ">
                {quote?.residency || "N/A"}
              </span>
            </div>
          </div>
        </div>
        {/* Plan Details */}
        {selectedPlans.length > 0 ? (
          <div className="space-y-4">
            {selectedPlans.map((plan, index) => (
              <div
                key={index}
                className="flex justify-center w-full md:h-[210px] min-h-[210px] flex-col md:flex-row mt-2"
              >
                {/* Left section with plan info */}
                <div className="w-full md:w-[70%] flex md:flex-row flex-col gap-x-10 rounded-t-2xl md:rounded-none md:rounded-l-2xl bg-white h-full">
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-1 p-4">
                    <div className="w-full px-2">
                      <label className="block mb-2 text-xs font-semibold text-[#ABABAB]">
                        Plan Name
                      </label>
                      <div className="font-semibold text-[14px] text-gray-900">
                        {plan.plan_name || "N/A"}
                      </div>
                    </div>
                    <div className="w-full px-2">
                      <label className="block mb-2 text-xs font-semibold text-[#ABABAB]">
                        No of Persons
                      </label>
                      <div className="font-semibold text-[14px] text-gray-900">
                        {quote && quote.members
                          ? JSON.parse(quote.members).length
                          : 0}
                      </div>
                    </div>
                    <div className="w-full px-2">
                      <label className="block mb-2 text-xs font-semibold text-[#ABABAB]">
                        Area Of Cover
                      </label>
                      <div className="font-semibold text-[14px] text-gray-900">
                        {plan.area ? plan.area.name : "N/A"}
                      </div>
                    </div>
                    <div className="w-full px-2">
                      <label className="block mb-2 text-xs font-semibold text-[#ABABAB]">
                        Annual Limit
                      </label>
                      <div className="font-semibold text-[14px] text-gray-900">
                        {plan.annual_limit
                          ? `$${commasNumber1(plan.annual_limit)}`
                          : "N/A"}
                      </div>
                    </div>
                    <div className="w-full px-2">
                      <label className="block mb-2 text-xs font-semibold text-[#ABABAB]">
                        Total Amount
                      </label>
                      <div className="font-semibold text-[14px] text-gray-900">
                        {plan.total_amount
                          ? `$${commasNumber1(plan.total_amount)}`
                          : "N/A"}
                      </div>
                    </div>
                    <div className="w-full px-2">
                      <label className="block mb-2 text-xs font-semibold text-[#ABABAB]">
                       Copay or Deductibles
                      </label>
                      <div className="font-semibold text-[14px] text-gray-900">
                        {plan.deductible_or_copay || "NIL"}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Right section with premium */}
                <div className="bg-custom-gradient text-center flex flex-col rounded-b-2xl md:rounded-b-none md:rounded-r-2xl items-center justify-center text-white h-full md:w-[30%] lg:w-[35%] sm:w-[100%] p-5">
                  <h1>Annual Premium</h1>
                  <p>
                    {plan.total_amount
                      ? `$${commasNumber1(plan.total_amount)}`
                      : "N/A"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>No plans selected.</p>
        )}

        {/* Members Table */}
        <div className="lg:mt-0 md:mt-28">
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              paddingTop: "20px",
              borderRadius: "18px",
              p: { xs: 2, md: 1 },
              backgroundColor: "white",
              mt: 1,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", md: 600 },
                pb: 3,
              }}
            >
              <Typography
                align="center"
                sx={{
                  paddingTop: 0,
                  paddingBottom: 2,
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                Members
              </Typography>
              <DataGrid
                rows={members}
                columns={columns}
                hideFooter
                disableColumnMenu
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    borderBottom: "1px solid #e0e0e0",
                    backgroundColor: "transparent",
                    color: "#888",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    lineHeight: "100px",
                  },
                  "& .MuiDataGrid-cell": {
                    textAlign: "center",
                    borderBottom: "1px solid #e0e0e0",
                  },
                  "& .MuiDataGrid-row": {
                    borderBottom: "none",
                  },
                  border: "none",
                  boxShadow: "none",
                  width: "100%",
                  maxWidth: { xs: "100%", md: 600 },
                  fontSize: { xs: "12px", md: "14px" },
                }}
                autoHeight
              />
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default ViewQuote;
